import React from "react";
import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";

const Testimonial = () => {
  <h2>scroll down</h2>;

  const zoomElement = document.querySelector(".zoom1");
  let zoom = 1;
  const ZOOM_SPEED = 0.05;

  document.addEventListener("wheel", function (e) {
    if (e.deltaY > 0) {
    zoomElement.style.transform = `scale(${(zoom += ZOOM_SPEED)})`;
    } else {
    zoomElement.style.transform = `scale(${(zoom = ZOOM_SPEED)})`;
    }
  });

    return (
      <div className="zoom1">
        <h1>allybaty@gmail.com</h1>
      
      </div>
    );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg"
);
